import React from 'react';

import PageHeader from '../components/header/page';
import Accordion from '../components/accordion'
import '../../sass/style.scss';


export default class FaqPage extends React.Component {
  constructor(props) {
      super(props)
      this.state = {}
  }

  render() {
    let {children, location} = this.props;
    let faqnumber = location.search.substr(1);
    return  (
      <main>
        <PageHeader headline="Häufig gestellte Fragen" />
        <Accordion route={faqnumber} />
      </main>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/faq.js